// Core
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Redux
import { useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";
import { membersApiSlice } from "state/members/membersApiSlice";
import { metersApiSlice } from "state/meters/metersApiSlice";
import { resourcesApiSlice } from "state/resources/resourcesApiSlice";
import store from "state/store";

const Prefetch = () => {
  const community = useSelector(selectCurrentCommunity);

  React.useEffect(() => {
    if (community?.id) {
      store.dispatch(
        membersApiSlice.util.prefetch(
          "getMembersByCommunityId",
          { communityId: community.id, excludeDeleted: "true" },
          {
            force: true,
          }
        )
      );
      store.dispatch(
        resourcesApiSlice.util.prefetch(
          "getResourcesByCommunityId",
          { communityId: community.id, excludeDeleted: "true" },
          {
            force: true,
          }
        )
      );
      store.dispatch(
        metersApiSlice.util.prefetch(
          "getMetersByCommunityId",
          { communityId: community.id, excludeDeleted: "true" },
          {
            force: true,
          }
        )
      );
    }
  }, [community?.id]);

  return community?.id ? <Outlet /> : <Navigate to="/communities" replace />;
};
export default Prefetch;
